import React from 'react';
import styled from 'styled-components';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { IncompleteSections } from './utils';

interface IncompleteListProps {
  items: IncompleteSections[];
  handleClick: (item: IncompleteSections, index: number) => unknown;
}

const StyledDiv = styled.div`
  max-width: 827px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid ${COLORS.grayLight};
  background-color: ${COLORS.grayLightest};
  padding: ${SPACERS.medium};
  .border-bottom {
    border-bottom: 1px solid ${COLORS.grayLight};
  }
  .space-top {
    padding-top: ${SPACERS.medium};
  }
  .space-bottom {
    padding-bottom: ${SPACERS.medium};
  }
  .item {
    display: flex;
    justify-content: space-between;
    .left-section {
      padding-right: ${SPACERS.medium};
      .main-heading {
        margin-bottom: ${SPACERS.tiny};
      }
    }
  }
`;

const IncompleteList: React.FC<IncompleteListProps> = ({
  items,
  handleClick,
}) => {
  const total = items.length;
  return (
    <StyledDiv>
      {items.map((item, i) => {
        const onClick = () => handleClick(item, i);
        return (
          <div
            key={item.feedbackSectionId || i}
            className={`item${i !== 0 ? ' space-top' : ''}${
              i !== total - 1 ? ' space-bottom border-bottom' : ''
            }`}
          >
            <div className="left-section">
              <TrueImpactText variant="body-bold" className="main-heading">
                Please complete the {item.sectionName} section of your report.
              </TrueImpactText>
              <TrueImpactText className="subheading">
                {item.helperText}
              </TrueImpactText>
            </div>
            <TrueImpactButton onClick={onClick}>Take me there</TrueImpactButton>
          </div>
        );
      })}
    </StyledDiv>
  );
};

export default IncompleteList;
